<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12">
                    <validation-observer ref="form">
                        <form action="" class="row">
                            <div class="form-section w-100">
                                <h2 class="heading-spacing--large pb-2">
                                    Persoonsgegevens
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonFirstname
                                        "
                                        class="col-12 col-md-5"
                                        name="Voornaam"
                                        rules="required"
                                        @input="updateParentInformation"
                                    />
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonInsertion
                                        "
                                        class="col-12 col-md-2"
                                        name="Tussenvoegsel"
                                        @input="updateParentInformation"
                                    />
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonLastname
                                        "
                                        class="col-12 col-md-5"
                                        name="Achternaam"
                                        rules="required"
                                        @input="updateParentInformation"
                                    />
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonPhone
                                        "
                                        class="col-12 col-md-7"
                                        name="Telefoonnummer"
                                        rules="required|digits:10"
                                        @input="updateParentInformation"
                                    />
                                </div>
                            </div>

                            <div class="form-section w-100">
                                <h2 class="heading-spacing--medium pb-2">
                                    Ouder/Voogd van
                                </h2>
                                <div
                                    v-for="(child,
                                    index) in profileUpdate.ChildrenData"
                                    id="child-row"
                                    :key="index"
                                    class="row"
                                >
                                    <text-input
                                        v-model="child.ChildFirstname"
                                        class="col-12 col-md-3"
                                        name="Voornaam"
                                        rules="required"
                                        @input="updateParentInformation"
                                    />
                                    <text-input
                                        v-model="child.ChildInsertion"
                                        class="col-12 col-md-2"
                                        name="Tussenvoegsel"
                                        @input="updateParentInformation"
                                    />
                                    <text-input
                                        v-model="child.ChildLastname"
                                        class="col-12 col-md-2"
                                        name="Achternaam"
                                        rules="required"
                                        @input="updateParentInformation"
                                    />
                                    <text-input
                                        v-model="child.ChildGroup"
                                        class="col-12 col-md-2"
                                        name="groep"
                                        rules="required"
                                        @input="updateParentInformation"
                                    />
                                    <text-input
                                        v-model="child.ChildSchool"
                                        class="col-12 col-md-2"
                                        name="school"
                                        rules="required"
                                        @input="updateParentInformation"
                                    />
                                    <div data-app>
                                        <v-dialog
                                            v-model="dialogChild"
                                            transition="dialog-bottom-transition"
                                            max-width="600"
                                        >
                                            <template
                                                v-slot:activator="{
                                                    on,
                                                    attrs
                                                }"
                                            >
                                                <button
                                                    class="btn-trash"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click.prevent
                                                >
                                                    <span>
                                                        <i
                                                            class="fas fa-trash-alt"
                                                        ></i>
                                                    </span>
                                                </button>
                                            </template>

                                            <v-card>
                                                <v-card-title
                                                    class="headline grey lighten-2"
                                                >
                                                    Weet je het zeker?
                                                </v-card-title>

                                                <v-card-text>
                                                    Weet je zeker dat je deze
                                                    gegevens wil verwijderen?
                                                </v-card-text>

                                                <v-divider></v-divider>

                                                <v-card-actions>
                                                    <button
                                                        class="btn btn--small col-md-5 btn--green-1"
                                                        @click.prevent="
                                                            removeChildComponent(
                                                                index
                                                            ),
                                                                updateSchoolInformation,
                                                                (dialogChild = false)
                                                        "
                                                    >
                                                        <span>Verwijderen</span>
                                                    </button>
                                                    <button
                                                        class="btn col-md-5 offset-md-1 btn--small btn--culture"
                                                        text
                                                        @click.prevent="
                                                            dialogChild = false
                                                        "
                                                    >
                                                        <span
                                                            >Nee,
                                                            annuleren</span
                                                        >
                                                    </button>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </div>
                                </div>
                                <div class="col-11 mt-4 text-right pr-0">
                                    <button
                                        class="btn btn--blue-7"
                                        @click.prevent="addChildComponent"
                                    >
                                        <span class="pl-2">
                                            Kind toevoegen
                                            <i class="fas fa-plus ml-2"></i>
                                        </span>
                                    </button>
                                </div>
                                <div class="form-section">
                                    <h2 class="heading-spacing--medium pb-2">
                                        Contactgegevens
                                    </h2>
                                    <div class="row">
                                        <text-input
                                            v-model="profileUpdate.Street"
                                            class="col-12 col-md-5"
                                            name="Straatnaam"
                                            @input="updateParentInformation"
                                        />
                                        <text-input
                                            v-model="profileUpdate.Housenumber"
                                            class="col-6 col-md-2"
                                            name="Huisnummer"
                                            type="number"
                                            @input="updateParentInformation"
                                        />
                                        <text-input
                                            v-model="
                                                profileUpdate.HousenumberAddition
                                            "
                                            class="col-6 col-md-2"
                                            name="Toevoeging"
                                            @input="updateParentInformation"
                                        />
                                        <text-input
                                            v-model="profileUpdate.Zipcode"
                                            class="col-12 col-md-5"
                                            name="Postcode"
                                            @input="updateTeacherInformation"
                                        />
                                        <text-input
                                            v-model="profileUpdate.City"
                                            class="col-12 col-md-5"
                                            name="Plaats"
                                            @input="updateParentInformation"
                                        />
                                    </div>
                                </div>

                                <editPassword
                                    :profile="profileUpdate"
                                    class="col-12 col-md-6 login-small"
                                    @input="updateParentInformation"
                                />
                                <dashboardMessage
                                    :message="responseMsg"
                                    :process="processing"
                                />
                            </div>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
        <error-bar v-if="errorMessage" :error-message="errorMessage" />
    </section>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { initVeeValidate } from '@/plugins/vee-validate';
import textInput from '@/components/form/text-input';
import editPassword from '@/components/form/edit-password';
import errorBar from '@/components/clientdashboard/dashboard-profile/error-bar';
import dashboardMessage from '@/components/clientdashboard/dashboard-profile/clientdashboard-profile-message';
import Axios from 'axios';

initVeeValidate();

export default {
    components: {
        ValidationObserver,
        textInput,
        editPassword,
        dashboardMessage,
        errorBar
    },
    props: {
        profile: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            responseMsg: '',
            error: false,
            errorMessage: '',
            validationError: false,
            success: false,
            submitted: false,
            processing: false,
            dialogChild: false,
            profileUpdate: {
                Id: '',
                Street: '',
                Housenumber: '',
                HousenumberAddition: '',
                Zipcode: '',
                City: '',
                ContactPersonFirstname: '',
                ContactPersonInsertion: '',
                ContactPersonLastname: '',
                ContactPersonPhone: '',
                Email: '',
                Password: '',
                PasswordRepeat: '',
                ChildrenData: [
                    {
                        ChildFirstname: '',
                        ChildInsertion: '',
                        ChildLastname: '',
                        ChildGroup: '',
                        ChildSchool: {}
                    },
                    {
                        ChildFirstname: '',
                        ChildInsertion: '',
                        ChildLastname: '',
                        ChildGroup: '',
                        ChildSchool: {}
                    }
                ]
            }
        };
    },
    created() {
        this.profileUpdate = this.profile;
    },
    methods: {
        updateParentInformation() {
            this.submitted = true;
            this.processing = true;
            this.responseMsg = '';
            this.errorMessage = '';
            const self = this;

            this.$nextTick(() => {
                self.$refs.form.validate().then(success => {
                    if (success) {
                        Axios.post('/clientdashboard/parent/update', {
                            profile: self.profileUpdate
                        })
                            .then(response => {
                                self.response = response;
                                self.processing = false;
                                self.submitted = false;
                                self.error = false;
                                if (response.data.success) {
                                    self.responseMsg = response.data.successMsg;
                                    self.profileUpdate.Password = null;
                                    self.profileUpdate.PasswordRepeat = null;
                                } else {
                                    self.errorMessage = response.data.errorMsg;
                                }
                                setTimeout(function() {
                                    self.responseMsg = '';
                                    self.errorMessage = '';
                                }, 5000);
                                return;
                            })
                            .catch(error => {
                                self.errorMessage =
                                    error.response.data.ExceptionMessage;
                                setTimeout(function() {
                                    self.errorMessage = '';
                                }, 5000);
                            })
                            .finally(() => {
                                self.processing = false;
                            });
                    } else {
                        self.processing = false;
                        self.error = true;
                    }
                });
            });
        },
        addChildComponent() {
            this.profileUpdate.ChildrenData.push({
                ChildFirstname: '',
                ChildInsertion: '',
                ChildLastname: '',
                ChildGroup: ''
            });
            return;
        },
        removeChildComponent(index) {
            this.profileUpdate.ChildrenData.splice(index - 1, 1);
            this.updateParentInformation();
            return;
        }
    }
};
</script>
<style>
#child-row .btn-trash {
    visibility: hidden;
    background-color: #fbfbfb;
    border-radius: 50%;
    width: 56px;
    height: 56px;
    border: 1px #000000 solid;
    margin-top: 50px;
}
#child-row:hover .btn-trash {
    visibility: visible;
}
</style>
